import { Form, Input, message } from "antd";
import { Api } from "../../../../../api/configApi";
import Boton from "../../../../../components/design/elementos/boton";

function IntegracionFad(values) {
  function guardar(values) {
    Api(
      "Cuentas",
      "InsertIntegracion",
      { tipoIntegracion: "firmaElectronica", proveedor: "Fad" },
      values
    ).then((res) => {
      if (res.success) {
        message.success("Integración Fad guardada");
      } else {
        message.error("Algo no salio bien.");
      }
    });
  }
  return (
    <Form onFinish={guardar} layout="vertical">
      <Form.Item
        rules={[{ required: true, message: "campo obligatorio" }]}
        label="Username"
        name="username"
      >
        <Input />
      </Form.Item>
      <Form.Item
        rules={[{ required: true, message: "campo obligatorio" }]}
        label="Contraseña"
        name="password"
      >
        <Input.Password />
      </Form.Item>

      <Boton texto="Guardar" htmlType="submit" />
    </Form>
  );
}

export default IntegracionFad;
